import { requestWithAuth } from "./http";

const API_BASE = "https://api.touchprop.com/api/v1/notifications";
const FALLBACK_MESSAGE = "خطا در دریافت اعلان‌ها";

const request = (path, options = {}) =>
  requestWithAuth(`${API_BASE}${path}`, options, { fallbackMessage: FALLBACK_MESSAGE });

export function getNotifications() {
  return request("/");
}

export function markNotificationRead(id) {
  return request(`/${id}/read/`, { method: "POST" });
}
